"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toAuthSession = toAuthSession;
exports.saveAuthSession = saveAuthSession;
exports.loadAuthSession = loadAuthSession;
exports.clearAuthSession = clearAuthSession;
exports.markSessionExpired = markSessionExpired;
exports.hasSessionExpired = hasSessionExpired;
exports.clearSessionExpired = clearSessionExpired;
exports.saveLastActivity = saveLastActivity;
exports.loadLastActivity = loadLastActivity;
exports.saveLastHeartbeat = saveLastHeartbeat;
exports.loadLastHeartbeat = loadLastHeartbeat;
var AUTH_STORAGE_KEY = "admin";
var SESSION_EXPIRED_STORAGE_KEY = "session-expired";
var LAST_ACTIVITY_STORAGE_KEY = "last-activity";
var LAST_HEARTBEAT_STORAGE_KEY = "last-heartbeat";
// The login endpoint returns the user with duplicate `id` and `uid`
// fields; collapse them into a single `_uid` before storing.
function toAuthSession(content) {
    var user = content.user, session = __rest(content, ["user"]);
    if (!user)
        return session;
    var id = user.id, uid = user.uid, rest = __rest(user, ["id", "uid"]);
    return __assign(__assign({}, session), { user: __assign(__assign({}, rest), { _uid: uid !== null && uid !== void 0 ? uid : id }) });
}
function saveAuthSession(session) {
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(session));
}
function loadAuthSession() {
    var raw = localStorage.getItem(AUTH_STORAGE_KEY);
    if (!raw)
        return null;
    try {
        return JSON.parse(raw);
    }
    catch (_a) {
        return null;
    }
}
function clearAuthSession() {
    localStorage.removeItem(AUTH_STORAGE_KEY);
}
function markSessionExpired() {
    sessionStorage.setItem(SESSION_EXPIRED_STORAGE_KEY, "true");
}
function hasSessionExpired() {
    return sessionStorage.getItem(SESSION_EXPIRED_STORAGE_KEY) === "true";
}
function clearSessionExpired() {
    sessionStorage.removeItem(SESSION_EXPIRED_STORAGE_KEY);
}
function loadTimestamp(key) {
    var value = Number(localStorage.getItem(key));
    return value > 0 ? value : null;
}
function saveLastActivity(timestamp) {
    localStorage.setItem(LAST_ACTIVITY_STORAGE_KEY, String(timestamp));
}
function loadLastActivity() {
    return loadTimestamp(LAST_ACTIVITY_STORAGE_KEY);
}
function saveLastHeartbeat(timestamp) {
    localStorage.setItem(LAST_HEARTBEAT_STORAGE_KEY, String(timestamp));
}
function loadLastHeartbeat() {
    return loadTimestamp(LAST_HEARTBEAT_STORAGE_KEY);
}
